export const CURSES = "/api/cursus"
export const CURSUS = "/api/cursus/:param"
export const CURSUS_ACTIVATE = "/api/cursus/:param/activate"
export const CURSUS_DEACTIVATE = "/api/cursus/:param/deactivate"

